import React from "react";

import { Wrapper,Content } from "./Vraag.styles";

 const Vraag = ({nommer1,nommer2}) =>(

    <Wrapper>
        <Content>
           <div>
            {nommer1} x {nommer2}
           </div>
        </Content>
    </Wrapper>

 );





export default Vraag;